import { ApiPaginatedRequestDto } from '@app/api/common-dtos';

export enum ImGroupFilterConditionEnum {
  My = 0,
  All = 1,
}

export interface ImGroupFilterDto {
  match?: string;
  filterCondition?: ImGroupFilterConditionEnum;
  puIds?: string[];
  userIds?: string[];
}

export interface ImGroupListRequestDto extends ApiPaginatedRequestDto {
  filter?: ImGroupFilterDto;
}
